import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const SupplierProducts = ({ supplierId }) => {
  const Navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (supplierId) {
      fetchSupplierProducts();
    }
  }, [supplierId]);

  const fetchSupplierProducts = () => {
    const token = localStorage.getItem("Token");

    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/supplier_products?supplier_id=${supplierId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const allProducts = res?.data?.data?.products || [];

        const filteredProducts = allProducts.filter(
          (product) =>
            product.user_id === supplierId ||
            product.supplier_id === supplierId ||
            product.created_by === supplierId
        );

        setProducts(filteredProducts);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  // if (loading) {
  //   return (
  //     <div className="text-center py-4">
  //       <div className="spinner-border text-primary" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }

  if (products.length === 0) {
    return (
      <div className="text-center py-4">
        <h6 style={{ color: "#1e1e1e" }}>
          No products found for this supplier
        </h6>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Product Image
            </th>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Name
            </th>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Size
            </th>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Description
            </th>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Date & Time
            </th>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Status
            </th>
            <th
              style={{ fontSize: "14px", color: "black", textAlign: "center" }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {products.map((item, index) => {
            let images = [];
            try {
              images = JSON.parse(item?.product_image || "[]");
            } catch (e) {
              images = [item?.product_image];
            }

            const firstImage = images?.[0]
              ? `${process.env.REACT_APP_IMAGE_URL}${images[0]}`
              : "/no-image.png";

            return (
              <tr key={index}>
                <td style={{ fontSize: "14px", textAlign: "center" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "50px",
                      height: "50px",
                      borderRadius: "8px",
                      overflow: "hidden",
                      margin: "0 auto",
                    }}
                  >
                    <img
                      src={firstImage}
                      alt="Product"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {item.title || "N/A"}
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {item?.size || "N/A"}
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                    maxWidth: "200px",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={item?.description?.replace(/<[^>]+>/g, "")}
                  >
                    {item?.description?.replace(/<[^>]+>/g, "") || "N/A"}
                  </div>
                </td>
                <td
                  style={{
                    fontSize: "14px",
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  {item?.created_at
                    ? new Date(item?.created_at).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                    : "N/A"}
                </td>
                <td style={{ fontSize: "14px", textAlign: "center" }}>
                  <span
                    className={`badge ${
                      item.is_active ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {item.is_active ? "Active" : "Inactive"}
                  </span>
                </td>
                <td style={{ fontSize: "14px", textAlign: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() =>
                      Navigate("/admin/supplier-product-show", {
                        state: {
                          id: item?.user_id,
                          name: item?.title,
                          size: item?.size,
                          print_coverage: item?.print_coverage,
                          paper_gsm: item?.paper_gsm,
                          no_of_ply: item?.no_of_ply,
                          material_color: item?.material_color,
                          lamination: item?.lamination,
                          burst_factor: item?.burst_factor,
                          created_at: item?.created_at,
                          description: item?.description,
                          product_image: item?.product_image,
                          quantity: item?.quantity,
                        },
                      })
                    }
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1b55e2"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ cursor: "pointer" }}
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SupplierProducts;
